var map = {
	"./apple-laurel-da-DK.svg": 53030,
	"./apple-laurel-de-DE.svg": 33492,
	"./apple-laurel-en-GB.svg": 45998,
	"./apple-laurel-en-US.svg": 98821,
	"./apple-laurel-es-ES.svg": 78398,
	"./apple-laurel-es-MX.svg": 42205,
	"./apple-laurel-fr-FR.svg": 78750,
	"./apple-laurel-it-IT.svg": 68572,
	"./apple-laurel-nb-NO.svg": 94915,
	"./apple-laurel-nl-NL.svg": 95546,
	"./apple-laurel-pl-PL.svg": 9010,
	"./apple-laurel-pt-BR.svg": 27966,
	"./apple-laurel-pt-PT.svg": 56786,
	"./apple-laurel-sv-SE.svg": 88511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;